var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17V31L8 32L13 31V17L8 16L3 17Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 24V38C37 39.657 35.657 41 34 41H13L12 36L13 31H27V24L32 23L37 24Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 10V24H27V17H13L12 12L13 7H34C35.657 7 37 8.343 37 10Z",
    fill: "#FBC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31V41H6C4.343 41 3 39.657 3 38V31H13Z",
    fill: "#1565C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7V17H3L13 7Z",
    fill: "#E53935"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24L37 32.45L27 24L37 15.55L38 24Z",
    fill: "#2E7D32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10.11V37.89C46 38.73 45.02 39.2 44.37 38.67L37 32.45V15.55L44.37 9.32999C45.02 8.79999 46 9.26999 46 10.11Z",
    fill: "#4CAF50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.745ab84e1851d10cd6d9b992c191d972.svg";
export { ForwardRef as ReactComponent };